module.exports = __webpack_public_path__ + "static/media/hangout.d9736639.png";